import { removeUndefined } from 'commonUtils/removeUndefined';
import { BFF_API_ROUTES } from 'constants/apiRoutes';

import { baseRTKApi } from 'shared/api/baseApi';

import type { TStClickRequest, TStClickResponse, TStPostbackRequest } from '../types';

const mapStClickRequestToQueryParams = ({
  affId,
  offerId,
  rootTransactionId,
  isFirstTouch,
  source,
  affSub1,
  affSub2,
  affSub3,
  affSub4,
  affSub5,
  affSub6,
  affSub7,
  affSub8,
  affSub9,
  affSub10,
}: TStClickRequest) =>
  removeUndefined({
    aff_id: affId,
    offer_id: offerId,
    root_transaction_id: rootTransactionId,
    isFirstTouch: isFirstTouch ? true : undefined,
    source,
    aff_sub1: affSub1,
    aff_sub2: affSub2,
    aff_sub3: affSub3,
    aff_sub4: affSub4,
    aff_sub5: affSub5,
    aff_sub6: affSub6,
    aff_sub7: affSub7,
    aff_sub8: affSub8,
    aff_sub9: affSub9,
    aff_sub10: affSub10,
  });

export const stTrackingApi = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    stTrackingClick: build.mutation<TStClickResponse, TStClickRequest>({
      query: (request) => ({
        url: BFF_API_ROUTES.stTrackingClick,
        method: 'GET',
        params: mapStClickRequestToQueryParams(request),
      }),
      extraOptions: { maxRetries: 0 },
    }),
    stTrackingPostback: build.mutation<void, TStPostbackRequest>({
      query: ({ transactionId, goalName, fullName, mobilePhone, scorePoint }) => ({
        url: BFF_API_ROUTES.stTrackingPostback,
        method: 'GET',
        params: {
          transaction_id: transactionId,
          goal_name: goalName,
          fullName,
          mobilePhone,
          scorePoint,
        },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});
